import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const DIRECTION_LEFT = 'left';
export const DIRECTION_RIGHT = 'right';
export const DIRECTION_UP = 'up';
export const DIRECTION_DOWN = 'down';

const points = [
  '10',
  '1.86321757',
  '8.10810809',
  '0',
  '0',
  '7.98521826',
  '8.10810809',
  '15.9704364',
  '10',
  '14.1072189',
  '3.78378374',
  '7.98521826',
].join(' ');

const transforms = {
  up: 'translate(8, 4) rotate(90 4 4)',
  right: 'translate(4, 8) rotate(180 4 4)',
  down: 'translate(0, 8) rotate(270 4 4)',
  left: 'translate(0, 0) rotate(0 4 4)',
};

// TODO: Switch this from `style` to `s` to prevent conflict with builtin
// `style` attribute
const Svg = styled.svg`
  width: ${(props) => props.style.width || '1rem'};
  height: ${(props) => props.style.height || 'auto'};
  fill: ${(props) => props.style.fill || '#000'};
  vertical-align: ${(props) => props.style.verticalAlign || 'initial'};
`;

const Chevron = ({ style, className, direction }) => (
  <Svg style={style} className={className} viewBox="0 0 16 16">
    <polygon points={points} transform={transforms[direction]} />
  </Svg>
);

Chevron.defaultProps = {
  direction: DIRECTION_LEFT,
  className: null,
  style: {},
};

Chevron.propTypes = {
  direction: PropTypes.oneOf([DIRECTION_LEFT, DIRECTION_RIGHT, DIRECTION_UP, DIRECTION_DOWN]),
  className: PropTypes.string,
  style: PropTypes.shape({
    width: PropTypes.string,
    height: PropTypes.string,
    fill: PropTypes.string,
    verticalAlign: PropTypes.string,
  }),
};

export default Chevron;
